import { useEffect, useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogContentText,
	DialogActions,
} from "@mui/material";
import { Button } from "@chatscope/chat-ui-kit-react";

export function confirmDialog(detail: {
	message: string;
	accept: () => void;
	reject: () => void;
}) {
	window.dispatchEvent(new CustomEvent("confirm-dialog", { detail }));
}

export const ConfirmDialog = () => {
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState("");
	const [accept, setAccept] = useState(() => () => {});
	const [reject, setReject] = useState(() => () => {});

	const confirm = (e: Event) => {
		const ev = e as CustomEvent;
		setMessage(ev.detail.message);
		setAccept(() => ev.detail.accept);
		setReject(() => ev.detail.reject);
		setOpen(true);
	};

	useEffect(() => {
		window.addEventListener("confirm-dialog", confirm);
		return () => {
			window.removeEventListener("confirm-dialog", confirm);
		};
	}, []);

	return (
		<Dialog open={open} onClose={() => setOpen(false)}>
			<DialogContent>
				<DialogContentText>{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => {
						setOpen(false);
						reject();
					}}
				>
					No
				</Button>
				<Button
					onClick={() => {
						setOpen(false);
						accept();
					}}
					autoFocus
				>
					Yes
				</Button>
			</DialogActions>
		</Dialog>
	);
};
